@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.beneficiary.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mobile_wallet.feature.beneficiary.generated.resources/"

internal val Res.string.delete_beneficiary_subtitle: StringResource by lazy {
      StringResource("string:delete_beneficiary_subtitle", "delete_beneficiary_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 115),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 103),
      ))
    }

internal val Res.string.delete_beneficiary_title: StringResource by lazy {
      StringResource("string:delete_beneficiary_title", "delete_beneficiary_title", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 126, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 114, 56),
      ))
    }

internal val Res.string.feature_beneficiary_account_no: StringResource by lazy {
      StringResource("string:feature_beneficiary_account_no", "feature_beneficiary_account_no", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 187, 58),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 171, 54),
      ))
    }

internal val Res.string.feature_beneficiary_account_type: StringResource by lazy {
      StringResource("string:feature_beneficiary_account_type", "feature_beneficiary_account_type", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 361, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 337, 56),
      ))
    }

internal val Res.string.feature_beneficiary_account_type_other: StringResource by lazy {
      StringResource("string:feature_beneficiary_account_type_other", "feature_beneficiary_account_type_other", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 246, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 226, 54),
      ))
    }

internal val Res.string.feature_beneficiary_account_type_wallet: StringResource by lazy {
      StringResource("string:feature_beneficiary_account_type_wallet", "feature_beneficiary_account_type_wallet", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 301, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 281, 55),
      ))
    }

internal val Res.string.feature_beneficiary_add: StringResource by lazy {
      StringResource("string:feature_beneficiary_add", "feature_beneficiary_add", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 665, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 617, 35),
      ))
    }

internal val Res.string.feature_beneficiary_add_beneficiary: StringResource by lazy {
      StringResource("string:feature_beneficiary_add_beneficiary", "feature_beneficiary_add_beneficiary", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 531, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 495, 63),
      ))
    }

internal val Res.string.feature_beneficiary_add_beneficiary_hint: StringResource by lazy {
      StringResource("string:feature_beneficiary_add_beneficiary_hint", "feature_beneficiary_add_beneficiary_hint", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 422, 108),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 394, 100),
      ))
    }

internal val Res.string.feature_beneficiary_added: StringResource by lazy {
      StringResource("string:feature_beneficiary_added", "feature_beneficiary_added", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 603, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 559, 57),
      ))
    }

internal val Res.string.feature_beneficiary_button_save: StringResource by lazy {
      StringResource("string:feature_beneficiary_button_save", "feature_beneficiary_button_save", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 709, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 653, 47),
      ))
    }

internal val Res.string.feature_beneficiary_button_update: StringResource by lazy {
      StringResource("string:feature_beneficiary_button_update", "feature_beneficiary_button_update", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 761, 57),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 701, 49),
      ))
    }

internal val Res.string.feature_beneficiary_cancel: StringResource by lazy {
      StringResource("string:feature_beneficiary_cancel", "feature_beneficiary_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 819, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 751, 42),
      ))
    }

internal val Res.string.feature_beneficiary_delete: StringResource by lazy {
      StringResource("string:feature_beneficiary_delete", "feature_beneficiary_delete", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1251, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1143, 42),
      ))
    }

internal val Res.string.feature_beneficiary_delete_beneficiary: StringResource by lazy {
      StringResource("string:feature_beneficiary_delete_beneficiary", "feature_beneficiary_delete_beneficiary", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 866, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 794, 70),
      ))
    }

internal val Res.string.feature_beneficiary_delete_confirmation_message: StringResource by lazy {
      StringResource("string:feature_beneficiary_delete_confirmation_message", "feature_beneficiary_delete_confirmation_message", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 941, 171),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 865, 151),
      ))
    }

internal val Res.string.feature_beneficiary_delete_failed: StringResource by lazy {
      StringResource("string:feature_beneficiary_delete_failed", "feature_beneficiary_delete_failed", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1113, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1017, 61),
      ))
    }

internal val Res.string.feature_beneficiary_deleted: StringResource by lazy {
      StringResource("string:feature_beneficiary_deleted", "feature_beneficiary_deleted", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1183, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1079, 63),
      ))
    }

internal val Res.string.feature_beneficiary_deleting: StringResource by lazy {
      StringResource("string:feature_beneficiary_deleting", "feature_beneficiary_deleting", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1298, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1186, 68),
      ))
    }

internal val Res.string.feature_beneficiary_edit_beneficiary: StringResource by lazy {
      StringResource("string:feature_beneficiary_edit_beneficiary", "feature_beneficiary_edit_beneficiary", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1371, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1255, 68),
      ))
    }

internal val Res.string.feature_beneficiary_error_empty_account_number: StringResource by lazy {
      StringResource("string:feature_beneficiary_error_empty_account_number", "feature_beneficiary_error_empty_account_number", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1444, 110),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1324, 94),
      ))
    }

internal val Res.string.feature_beneficiary_error_empty_beneficiary_name: StringResource by lazy {
      StringResource("string:feature_beneficiary_error_empty_beneficiary_name", "feature_beneficiary_error_empty_beneficiary_name", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1555, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1419, 100),
      ))
    }

internal val Res.string.feature_beneficiary_error_empty_office_name: StringResource by lazy {
      StringResource("string:feature_beneficiary_error_empty_office_name", "feature_beneficiary_error_empty_office_name", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1676, 111),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1520, 87),
      ))
    }

internal val Res.string.feature_beneficiary_error_invalid_transfer_limit: StringResource by lazy {
      StringResource("string:feature_beneficiary_error_invalid_transfer_limit", "feature_beneficiary_error_invalid_transfer_limit", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1788, 120),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1608, 108),
      ))
    }

internal val Res.string.feature_beneficiary_error_oops: StringResource by lazy {
      StringResource("string:feature_beneficiary_error_oops", "feature_beneficiary_error_oops", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1909, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1717, 46),
      ))
    }

internal val Res.string.feature_beneficiary_error_select_account_type: StringResource by lazy {
      StringResource("string:feature_beneficiary_error_select_account_type", "feature_beneficiary_error_select_account_type", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1956, 93),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1764, 85),
      ))
    }

internal val Res.string.feature_beneficiary_error_select_locale: StringResource by lazy {
      StringResource("string:feature_beneficiary_error_select_locale", "feature_beneficiary_error_select_locale", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2050, 99),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1850, 67),
      ))
    }

internal val Res.string.feature_beneficiary_locale: StringResource by lazy {
      StringResource("string:feature_beneficiary_locale", "feature_beneficiary_locale", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2150, 78),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1918, 42),
      ))
    }

internal val Res.string.feature_beneficiary_nickname: StringResource by lazy {
      StringResource("string:feature_beneficiary_nickname", "feature_beneficiary_nickname", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2229, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1961, 48),
      ))
    }

internal val Res.string.feature_beneficiary_no_beneficiaries: StringResource by lazy {
      StringResource("string:feature_beneficiary_no_beneficiaries", "feature_beneficiary_no_beneficiaries", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2286, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2010, 68),
      ))
    }

internal val Res.string.feature_beneficiary_office_name: StringResource by lazy {
      StringResource("string:feature_beneficiary_office_name", "feature_beneficiary_office_name", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2359, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2079, 55),
      ))
    }

internal val Res.string.feature_beneficiary_ok: StringResource by lazy {
      StringResource("string:feature_beneficiary_ok", "feature_beneficiary_ok", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2427, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2135, 34),
      ))
    }

internal val Res.string.feature_beneficiary_title_add: StringResource by lazy {
      StringResource("string:feature_beneficiary_title_add", "feature_beneficiary_title_add", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2470, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2170, 57),
      ))
    }

internal val Res.string.feature_beneficiary_title_update: StringResource by lazy {
      StringResource("string:feature_beneficiary_title_update", "feature_beneficiary_title_update", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2536, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2228, 64),
      ))
    }

internal val Res.string.feature_beneficiary_transfer_limit: StringResource by lazy {
      StringResource("string:feature_beneficiary_transfer_limit", "feature_beneficiary_transfer_limit", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2609, 74),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2293, 62),
      ))
    }

internal val Res.string.feature_beneficiary_unexpected_error_subtitle: StringResource by lazy {
      StringResource("string:feature_beneficiary_unexpected_error_subtitle", "feature_beneficiary_unexpected_error_subtitle", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2684, 137),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2356, 117),
      ))
    }

internal val Res.string.feature_beneficiary_updated: StringResource by lazy {
      StringResource("string:feature_beneficiary_updated", "feature_beneficiary_updated", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2822, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2474, 63),
      ))
    }

internal val Res.string.scan_qr_code: StringResource by lazy {
      StringResource("string:scan_qr_code", "scan_qr_code", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2890, 48),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2538, 36),
      ))
    }

internal val Res.string.skip_the_form: StringResource by lazy {
      StringResource("string:skip_the_form", "skip_the_form", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 2939, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2575, 41),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("delete_beneficiary_subtitle", Res.string.delete_beneficiary_subtitle)
  map.put("delete_beneficiary_title", Res.string.delete_beneficiary_title)
  map.put("feature_beneficiary_account_no", Res.string.feature_beneficiary_account_no)
  map.put("feature_beneficiary_account_type", Res.string.feature_beneficiary_account_type)
  map.put("feature_beneficiary_account_type_other", Res.string.feature_beneficiary_account_type_other)
  map.put("feature_beneficiary_account_type_wallet", Res.string.feature_beneficiary_account_type_wallet)
  map.put("feature_beneficiary_add", Res.string.feature_beneficiary_add)
  map.put("feature_beneficiary_add_beneficiary", Res.string.feature_beneficiary_add_beneficiary)
  map.put("feature_beneficiary_add_beneficiary_hint", Res.string.feature_beneficiary_add_beneficiary_hint)
  map.put("feature_beneficiary_added", Res.string.feature_beneficiary_added)
  map.put("feature_beneficiary_button_save", Res.string.feature_beneficiary_button_save)
  map.put("feature_beneficiary_button_update", Res.string.feature_beneficiary_button_update)
  map.put("feature_beneficiary_cancel", Res.string.feature_beneficiary_cancel)
  map.put("feature_beneficiary_delete", Res.string.feature_beneficiary_delete)
  map.put("feature_beneficiary_delete_beneficiary", Res.string.feature_beneficiary_delete_beneficiary)
  map.put("feature_beneficiary_delete_confirmation_message", Res.string.feature_beneficiary_delete_confirmation_message)
  map.put("feature_beneficiary_delete_failed", Res.string.feature_beneficiary_delete_failed)
  map.put("feature_beneficiary_deleted", Res.string.feature_beneficiary_deleted)
  map.put("feature_beneficiary_deleting", Res.string.feature_beneficiary_deleting)
  map.put("feature_beneficiary_edit_beneficiary", Res.string.feature_beneficiary_edit_beneficiary)
  map.put("feature_beneficiary_error_empty_account_number", Res.string.feature_beneficiary_error_empty_account_number)
  map.put("feature_beneficiary_error_empty_beneficiary_name", Res.string.feature_beneficiary_error_empty_beneficiary_name)
  map.put("feature_beneficiary_error_empty_office_name", Res.string.feature_beneficiary_error_empty_office_name)
  map.put("feature_beneficiary_error_invalid_transfer_limit", Res.string.feature_beneficiary_error_invalid_transfer_limit)
  map.put("feature_beneficiary_error_oops", Res.string.feature_beneficiary_error_oops)
  map.put("feature_beneficiary_error_select_account_type", Res.string.feature_beneficiary_error_select_account_type)
  map.put("feature_beneficiary_error_select_locale", Res.string.feature_beneficiary_error_select_locale)
  map.put("feature_beneficiary_locale", Res.string.feature_beneficiary_locale)
  map.put("feature_beneficiary_nickname", Res.string.feature_beneficiary_nickname)
  map.put("feature_beneficiary_no_beneficiaries", Res.string.feature_beneficiary_no_beneficiaries)
  map.put("feature_beneficiary_office_name", Res.string.feature_beneficiary_office_name)
  map.put("feature_beneficiary_ok", Res.string.feature_beneficiary_ok)
  map.put("feature_beneficiary_title_add", Res.string.feature_beneficiary_title_add)
  map.put("feature_beneficiary_title_update", Res.string.feature_beneficiary_title_update)
  map.put("feature_beneficiary_transfer_limit", Res.string.feature_beneficiary_transfer_limit)
  map.put("feature_beneficiary_unexpected_error_subtitle", Res.string.feature_beneficiary_unexpected_error_subtitle)
  map.put("feature_beneficiary_updated", Res.string.feature_beneficiary_updated)
  map.put("scan_qr_code", Res.string.scan_qr_code)
  map.put("skip_the_form", Res.string.skip_the_form)
}
